import { SortByEnum } from 'src/generated/graphql';

export const INSTITUTION_PAGE = {
  overview: {
    label: 'Overview',
    path: 'overview'
  },
  costsFederalAid: {
    label: 'Costs & Federal Aid',
    path: 'costs-federal-aid'
  },
  programs: {
    label: 'Programs',
    path: 'programs'
  },
  taInsights: {
    label: 'TA Insights',
    path: 'ta-insights'
  },
  vaInsights: {
    label: 'Dept. of Education & VA Insights',
    path: 'va-insights'
  }
};

export const INSTITUTION_TABS = [
  INSTITUTION_PAGE.overview,
  INSTITUTION_PAGE.costsFederalAid,
  INSTITUTION_PAGE.programs,
  INSTITUTION_PAGE.taInsights,
  INSTITUTION_PAGE.vaInsights
];

export const COST_OF_ATTENDANCE = {
  inStateTuition: {
    price: 0,
    label: 'In-State Tuition',
    info: 'The average in-state tuition/fees for an undergraduate student as reported by the school to the ED through IPEDS. Generally, in-state residents are charged a discounted rate of tuition and fees.'
  },
  outStateTuition: {
    price: 0,
    label: 'Out of State Tuition',
    info: 'The average tuition/fees charged to undergraduate students who are not residents of the state where the school is located, as reported by the school to the ED through IPEDS. '
  },
  roomBoard: {
    price: 0,
    label: 'Room and Board',
    info: 'The estimated cost for an undergraduate student’s room and board as reported by the school to the ED through IPEDS.'
  },
  booksSupplies: {
    price: 0,
    label: 'Books and Supplies',
    info: 'The average cost of books and supplies for a typical student for an entire academic year (or program) as reported to IPEDS. Does not include special costs for specific groups of students, unless they constitute the majority of students at an institution.'
  }
};

export const PAGING_CONFIG = {
  labels: {
    previousLabel: '<',
    nextLabel: '>',
    screenReaderPaginationLabel: 'Pagination',
    screenReaderPageLabel: 'page',
    screenReaderCurrentLabel: `You're on page`
  },
  config: {
    id: 'advanced',
    itemsPerPage: 15,
    currentPage: 1
  }
};

export const SORT_OPTIONS = [
  {
    value: SortByEnum.NameAsc,
    label: 'Alphabetical (A-Z)'
  },
  {
    value: SortByEnum.NameDesc,
    label: 'Alphabetical (Z-A)'
  },
  {
    value: SortByEnum.TaAsc,
    label: 'TA Participants (Low-High)'
  },
  {
    value: SortByEnum.TaDesc,
    label: 'TA Participants (High-Low)'
  }
];

export const PROGRAM_LEVEL = {
  certificate: 'Certificate',
  associate: 'Associate',
  bachelor: 'Bachelor',
  master: 'Master'
};

export const TUITION_TYPE = {
  military: 'military',
  inState: 'in-state',
  outOfState: 'out-state',
  distance: 'distance'
};

export const RATE_TYPE = {
  semesterHour: 'Semester',
  quarterHour: 'Quarter',
  contactHour: 'Contact'
};

export const RATE = {
  less: -1,
  more: 1
};

export const RATES = [
  {
    value: RATE.less,
    label: '$250 or Less'
  },
  {
    value: RATE.more,
    label: 'More than $250'
  }
];

export const TA_COMPLAINTS = [
  {
    label: 'Recruiting/Marketing Practices',
    field: 'recruitingMarketingPractices'
  },
  {
    label: 'Student Loans',
    field: 'studentLoans'
  },
  {
    label: 'Quality of Education',
    field: 'qualityEducation'
  },
  {
    label: 'Transfer of Credits',
    field: 'transferCredits'
  },
  {
    label: 'Accreditation',
    field: 'accreditation'
  },
  {
    label: 'Post-graduation Job Opportunities',
    field: 'postGradOpportunities'
  },
  {
    label: 'Grade Policy',
    field: 'gradePolicy'
  },
  {
    label: 'Refund/Collection Issues',
    field: 'refundIssues'
  },
  {
    label: 'Financial Issues',
    field: 'finacaialIssues'
  },
  {
    label: 'Change in Degree Plan Requirements',
    field: 'changeInDegreePlan'
  },
  {
    label: 'Release of Transcripts',
    field: 'releaseOfTranscripts'
  },
  {
    label: 'Other',
    field: 'otherIssues'
  }
];

export const VA_COMPLAINTS = [
  {
    label: 'Recruiting/Marketing Practices',
    field: 'recruitingMarketingPractices'
  },
  {
    label: 'Student Loans',
    field: 'studentLoans'
  },
  {
    label: 'Quality of Education',
    field: 'qualityEducation'
  },
  {
    label: 'Transfer of Credits',
    field: 'transferCredits'
  },
  {
    label: 'Accreditation',
    field: 'accreditation'
  },
  {
    label: 'Post-graduation Job Opportunities',
    field: 'postgraduationJobOpportunities'
  },
  {
    label: 'Grade Policy',
    field: 'gradePolicy'
  },
  {
    label: 'Refund/Collection Issues',
    field: 'refundIssues'
  },
  {
    label: 'Financial Issues',
    field: 'financialIssues'
  },
  {
    label: 'Change in Degree Plan Requirements',
    field: 'changeDegreePlanRequiremnts'
  },
  {
    label: 'Release of Transcripts',
    field: 'releaseTranscripts'
  },
  {
    label: 'Other',
    field: 'other'
  }
];
